module.exports = __webpack_public_path__ + "static/media/alameda.13970e0c.svg";